import { Route, Routes, useNavigate } from "react-router-dom";
import Helmet from "react-helmet"

// Layout
import Layout from "layouts/Default"
import IFrame from "layouts/IFrame";


// Views
import * as Pages from "pages";
// Routes
import {UrlPath} from "utility/routes";
import { useEffect } from "react";
import useAccountData from "hooks/useAccountData";
import { ProtectedRoute } from "components/Authentication/ProtectedRoute";
import { useAuth } from "react-oidc-context";
import { Seo } from "components/Seo";


function App() {
  
  const {collectCompanies} = useAccountData();
  var navigate = useNavigate();
  var auth = useAuth();

  async function fetchCompanies() {
    await collectCompanies();
  }

  useEffect(() => {
    if(auth.isAuthenticated) {
      fetchCompanies();
      navigate(UrlPath.MyAccount.Home)
    }
   
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [auth.isAuthenticated])
  return (
    <>
      <Seo />
      <Routes>
        <Route element={<Layout />}>
          <Route path={UrlPath.Frontpage.Home} element={<Pages.Frontpage />} />
          <Route path="/" element={<ProtectedRoute />}>
            <Route path={UrlPath.MyAccount.Home} element={<Pages.Account.MyAccount />} />
            <Route path={UrlPath.MyAccount.AddCompany} element={<Pages.Account.AddCompany/>} />
            <Route path={UrlPath.Account.Company} element={<Pages.Account.EditCompany />} />
            <Route path={UrlPath.Account.CompanyEdit} element={<Pages.Account.EditCompanyInfoList />} />
            <Route path={UrlPath.Account.CompanyEditElements} element={<Pages.Account.EditCompany />} />
            <Route path={UrlPath.Account.LogDetails} element={<Pages.Account.LoggDetails />} />
            <Route path={UrlPath.Account.Products} element={<Pages.Account.Products />} />
          </Route>
          <Route path="*" element={<Pages.Error404 />} /> 
        </Route>
        <Route element={<IFrame />}>
          <Route path={UrlPath.Account.Statistics} element={<Pages.Account.Statistics />} />
          <Route path={UrlPath.Account.InfoSite} element={<Pages.Account.InfoSite />} />
        </Route>
      </Routes>
      </>
  );
}
export default App;
